import { tv } from 'tailwind-variants'

import { caption } from '@ui-kit/core/typography'

export const circleButton = tv({
  slots: {
    container: 'flex flex-col gap-y-2.5',
    circle:
      'flex h-16 w-16 items-center justify-center overflow-hidden rounded-full border border-solid',
    text: caption({ className: 'w-16 text-center' }),
  },
  variants: {
    disabled: {
      true: {
        container: 'opacity-30',
      },
      false: {
        container: 'hover:opacity-50 active:opacity-50 web:transition web:duration-300',
      },
    },
  },
  defaultVariants: {
    disabled: false,
  },
})
